import { FlexRowSmallSpaced } from '@fox/layout';
import { useTheme } from 'styled-components';
import { getAttributeValues, transformLegacyProps } from '../../../../utils';
import { FormRenderMode } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../../form-runtime-context/form-runtime-context';
import { justifyDictionary, SpecialButton } from '../../transaction-block/styled-components';
import { QuestionBlockProps, QuestionChoice } from '../contracts';

interface IToggleOptionProps {
	options: QuestionChoice[];
	orientation?: 'vertical' | 'horizontal';
	currentValue: string | undefined;
	id: string;
	fieldProps: QuestionBlockProps;
}

export const ToggleButtons = (props: IToggleOptionProps) => {
	const { fieldProps, options, currentValue, orientation } = props;
	const questionName = fieldProps.name;

	const { formRenderMode, answerQuestion } = useFormRuntimeContext();

	const theme = useTheme();
	const data = fieldProps;
	const style = data?.style;

	const {
		attributes: { padding, margin }
	} = transformLegacyProps(null!, props);

	const { top: paddingTop, bottom: paddingBottom, right: paddingRight, left: paddingLeft } = getAttributeValues(padding);
	const { top: marginTop, bottom: marginBottom, right: marginRight, left: marginLeft } = getAttributeValues(margin);

	const styleObj = {
		paddingTop,
		paddingLeft,
		paddingBottom,
		paddingRight,
		marginLeft,
		marginTop,
		marginRight,
		marginBottom
	};

	const background = style?.backgroundColor ?? theme?.colors.secondary;
	const hoverBackgroundColour = style?.hoverBackgroundColour;
	const selectedBackgroundColour = style?.selectedColor;
	const color = style?.color ?? theme.colors.white;
	const buttonsAlignment = fieldProps.attributes?.horizontalAlign;

	return (
		<FlexRowSmallSpaced
			style={{
				...styleObj,
				justifyContent: buttonsAlignment ? justifyDictionary[buttonsAlignment] : 'flex-start',
				flexWrap: 'wrap'
			}}
		>
			{options.map((a, index) => (
				<SpecialButton
					key={`button_${index}_${a.id}`}
					type="button"
					$borderRadius={data.borderRadius}
					$fontFamily={style?.fontFamily}
					$fontSize={style?.fontSize}
					$borderSize={style?.borderSize}
					$borderColor={style?.borderColor}
					$fontWeight={style?.fontWeight}
					$fontStyle={style?.fontStyle}
					$textDecoration={style?.textDecoration}
					$background={background}
					$color={color}
					$hoverBackgroundColour={hoverBackgroundColour}
					$selected={`${a.displayName}` === currentValue}
					$selectedBackgroundColour={selectedBackgroundColour}
					onClick={() => {
						if (formRenderMode === FormRenderMode.design) {
							return;
						}
						const newAnswer = {
							questionName: questionName,
							answer: { answerString: a.value }
						};
						answerQuestion(newAnswer);
					}}
				>
					{a.displayName}
				</SpecialButton>
			))}
		</FlexRowSmallSpaced>
	);
};
